import i18n from '@/i18n'
import {filterRulesMapped} from '@/tools/filterRules'
import {profileService} from '@/services/profile.service'
import {mapActions, mapGetters} from 'vuex'
import {DialogType} from '@/constants/constants'
import {dialogTypes} from "@/constants/dialogTypes"
import ProfileDialogComponent from "@/components/profile/dialog/ProfileDialogComponent.vue"
import {DialogUserProfile, dialogUtil} from "@/tools/dialog"
import {clone} from 'ramda'
import Vue from 'vue'
import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import {SnackbarStyle} from '@/constants/constants'
import {enterpriseService} from '@/services/enterprise.service'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'ProfileABMComponent',
    components: {
        ProfileDialogComponent,
        TreeSelectorComponent,
        AutocompleteComponent
    },
    data: () => ({
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos
        tableData: [],
        // key de los datos de la tabla
        tableDataKey: 'id',
        // botones de cada fila
        rowActions: [
            {
                id: 1,
                name: i18n.t('modify'),
                color: 'blue',
                icon: 'fa-pen'
            },
            {
                id: 3,
                name: i18n.t('userProfiles.useAsTemplate'),
                color: 'red',
                icon: 'fa-clone'
            },
            {
                id: 2,
                name: i18n.t('delete'),
                color: 'red',
                icon: 'fa-trash-alt'
            }
        ],
        // botones del componente Tabla
        tableComponentButtons: [],
        dialog: {
            ...dialogTypes.USER_PROFILES,
        },
        // model del dialog
        showEditDialog: false,
        // título del dialog
        editDialogTitle: i18n.t('userProfiles.editDialog.titleNew'),
        // loading de la tabla
        loadingTable: true,
        // dialog para reasignar usuarios y eliminar un perfil
        showDeleteDialog: false,
        // id del perfil que se quiere eliminar
        deleteProfileId: null,
        // normalizer para el treeselect del dialog de eliminación
        deleteDialogSelectorNormalizer: (node) => {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            }
        },
        deleteDialogProfiles: [],
        // perfil seleccionado para la reasignación de usuarios en la eliminación
        deleteDialogSelectedProfile: null,
        // search tabla de usuarios en el dialog de reasignación de perfil
        searchAssociatedUsers: '',
        // headers de la tabla de usuarios asignados en el dialog de reasignación de perfil
        headersAssociatedUsers: [
            {
                text: i18n.t('userProfiles.associatedUsers'),
                align: 'left',
                sortable: true,
                value: 'username'
            }
        ],
        // datos de los usuarios asignados
        associatedUsers: [],
        // key de los datos de la tabla de usuarios asociados
        associatedUsersItemKey: '_id',
        // arreglo de empresas del selector
        enterprises: [],
        // empresa seleccionada
        enterpriseSelected: null,
        // Opción 'TODOS' para el selector de empresa
        all: {
            _id: 'ALL',
            name: i18n.t('all')
        }
    }),
    computed: {
        /**
         * getters del breadcrumb
         */
        ...mapGetters('breadcrumbs', [
            'getBread'
        ]),
        /**
         * Perfiles para el dialog de reasignación de usuarios
         */
        deleteDialogUserProfiles() {
            return this.tableData.filter(profile => profile.id !== this.deleteProfileId)
        },
        /**
         * Valor computado para hacer las requests al api
         */
        enterpriseSelectedArray() {
            if (this.enterpriseSelected) {
                if (this.enterpriseSelected === this.all._id) {
                    return this.enterprises.filter(enterprise => enterprise._id !== this.all._id)
                        .map(enterprise => enterprise._id);
                }
                return [this.enterpriseSelected];
            }
            return [];
        }
    },
    created() {
        /*
            Vuex watch del breadcrumb
        */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
            (newBreads) => {
                const lastElement = newBreads[newBreads.length - 1];
                if (!lastElement) {
                    this.cancel();
                    return;
                }
                this.dialog = dialogUtil.getDialog(lastElement.key, DialogUserProfile);
            },
            {deep: true})
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch();
        this.cleanBread();
    },
    mounted() {
        // inicialización de los datos del ABM
        this.initialize();
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'cleanBread'
        ]),
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * Para inicializar el componente
         */
        async initialize() {
            // Botón de creación
            /*
            if(this.validatePrivilegesAnd(['profile.create'])){
                this.tableComponentButtons.push({
                    id: 'add',
                    tooltip: i18n.t('add'),
                    icon: 'add_circle_outline',
                    action: this.showCreateDialog.bind(this),
                    selectedData: false
                })
            }
            */
            this.tableComponentButtons.push({
                id: 'add',
                tooltip: i18n.t('add'),
                icon: 'add_circle_outline',
                action: this.showCreateDialog.bind(this),
                selectedData: false
            });

            // empresas
            await this.initEnterpriseSelector();

            // cargo la tabla
            this.getData();
            this.resetFields();
            this.initBread();
        },
        /**
         * Inicializa el selector de empresas
         */
        async initEnterpriseSelector() {
            this.enterprises = await enterpriseService.getAllForSelector();
            this.dialog.model.enterprises = this.enterprises;
            if (this.enterprises.length > 1) {
                this.enterprises = ([this.all]).concat(this.enterprises);
                this.enterpriseSelected = this.all._id;
            } else if (this.enterprises.length === 1) {
                this.enterpriseSelected = this.enterprises[0]._id;
            }
        },
        /**
         * Obtiene los datos para la tabla del ABM
         * @param {*} update
         */
        async getData(update = false) {
            this.loadingTable = true;
            profileService.findAll(this.enterpriseSelectedArray).then(response => {
                const lastTableHeaders = clone(this.tableHeaders);
                this.tableData.cleanAndUpdate(response.data);
                if (update) {
                    Vue.nextTick( () => this.tableHeaders.cleanAndUpdate(lastTableHeaders));
                } else {
                    this.tableHeaders.cleanAndUpdate(response.headers);
                    this.setTableFilterRules();
                }
                this.loadingTable = false;
            })
        },
        /**
         * Refrescar la data
         */
        refreshTable() {
            this.getData(true);
        },
        /**
         * Setea las reglas de filtrado
         */
        setTableFilterRules() {
            this.tableFilterRules = {};
            this.tableHeaders.forEach(header => this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]);
        },
        /**
         * Carga los datos para el dialog de actualización
         * @param {*} data
         */
        loadFields(data) {
            const modelData = this.dialog.model;
            Object.assign(modelData, data);
            modelData.update = true;
            this.showUpdateDialog();
        },
        async rowButtonClicked(button, data) {
            let profileData;
            if (button.id === 2 && data.count) {
                profileData = await profileService.getProfileAndUsersById(data.id);
            } else {
                profileData = await profileService.getProfileById(data.id);
            }
            switch (button.id) {
                case 1:
                    // editar
                    this.loadFields(profileData);
                    break
                case 2:
                    // eliminar
                    if (data.count) {
                        this.deleteProfileId = data.id;
                        this.associatedUsers = profileData.users;
                        this.showDeleteDialog = true;
                    } else {
                        this.openDialog(
                            {
                                title: this.$t('userProfiles.deleteDialogTitle', {profileName: data.name}),
                                text: this.$t('userProfiles.deleteDialogText'),
                                type: DialogType.QUESTION,
                                actionButtons: true,
                                yesAction: () => this.delete(data.id)
                            })
                    }
                    break
                case 3:
                    // usar como plantilla
                    this.showCreateDialog(profileData);
                    break;
                default:
                    console.log('default');
            }
        },
        /**
         * Para eliminar un perfil
         * @param {*} id
         */
        async delete(id) {
            profileService.deleteOne(id).then(() => {
                this.showSnackbar({
                    visible: true,
                    text: this.$t('userProfiles.deleted'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                });
                this.refreshTable();
            })
        },
        /**
         * Clic fuera del dialog
         */
        clickOutside() {
            this.cancel();
        },
        /**
         * Cancelar
         */
        cancel() {
            this.resetFields();
            this.showEditDialog = false;
        },
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.dialog.model = {
                id: null,
                name: null,
                guest_user_profile: false,
                modules: [],
                update: false,
                actualName: null,
                enterpriseId: null,
                enterprises: this.enterprises.filter(enterprise => enterprise._id !== this.all._id)
            };
        },
        /**
         * Inicializa el breadcrumb del dialog
         */
        initBread() {
            const bread = {
                key: DialogUserProfile,
                disabled: true,
                text: this.$t('userProfiles.name')
            };
            this.pushBread(bread);
        },
        /**
         * Abre el dialog para creación
         * @param {*} templateData
         */
        showCreateDialog(templateData = undefined) {
            this.initBread();
            this.dialog.model.update = false;
            if (templateData) {
                this.dialog.model.modules = clone(templateData.modules);
                this.dialog.model.guest_user_profile = clone(templateData.guest_user_profile);
            }
            this.editDialogTitle = i18n.t('userProfiles.editDialog.titleNew');
            this.showEditDialog = true;
        },
        /**
         * Abre el dialog para actualización
         */
        showUpdateDialog() {
            this.initBread();
            this.editDialogTitle = i18n.t('userProfiles.editDialog.titleUpdate');
            this.showEditDialog = true;
        },
        /**
         * Paginador externo
         * @param {*} pageSize
         * @param {*} pageNumber
         */
        externalPaginator(pageSize, pageNumber) {
            this.pageNumber = Number(pageNumber);
            this.pageSize = Number(pageSize);
        },
        /**
         * Perfil seleccionado en el diálogo de reasignación de perfil para eliminar otro
         * @param {*} profileId
         */
        selectedProfile(profileId) {
            this.deleteDialogSelectedProfile = profileId;
        },
        /**
         * Elimina un perfil de usuario
         */
        reasssignAndDeleteProfile() {
            profileService.reasssignAndDeleteProfile(this.deleteProfileId, this.deleteDialogSelectedProfile, this.associatedUsers.map(user => user._id))
                .then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('userProfiles.deleted'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    });
                    this.refreshTable();
                })
        },
        /**
         * Cada vez que se modifica la selección de empresa, se cargan
         */
        enterpriseSelectedFunction(newValue) {
            this.enterpriseSelected = newValue._id ? newValue._id : newValue;
            this.getData(true);
        },
    },
}
